export const payInvoice = (invoice_id) => {
    return fetch('/api/v2/accounts/invoices/pay/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify({ invoice_id }),
    });
};
